import { setLoading } from "./loadingAction";
import apiConfig from "../../config/apiConfig";
import { toastType } from "../../constants";
import { addToast } from "./toastAction";

export const stockDetailsPurchaseExcel =
    (product, setIsWarehouseValue, filter = {}, isLoading = true) =>
    async (dispatch) => {
        if (isLoading) {
            dispatch(setLoading(true));
        }
        await apiConfig
            .get(`get-product-purchase-report-excel?product_id=${product}`)
            .then((response) => {
                if (response) {
                    window.open(
                        response.data.data.product_purchase_report_url,
                        "_blank"
                    );
                    setIsWarehouseValue(false);
                    dispatch(setLoading(false));
                }
            })
            .catch(({ response }) => {
                if (response) {
                    dispatch(
                        addToast({
                            text: response.data.message,
                            type: toastType.ERROR,
                        })
                    );
                }
            });
    };
